import { Stack } from '@mui/material'
import { tokens } from 'ComponentLibrary'
import { Typography } from 'ComponentLibrary/src/piazza/text'
import { useFlags } from 'ClientPortal/src/context/FeatureFlagContext'
import { PlaceholderCard } from 'ClientPortal/src/pages/MarketData/Placeholder/NoDataPlaceholder'
import { Pulse } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

export const MarketDataNoSelection = () => {
    const { isMarketDataEnabled } = useFlags()
    const { t } = useTranslation('pages', { keyPrefix: 'marketData' })
    const noDataText = isMarketDataEnabled ? t('noSelection.selectAssetOrCustomLocation') : t('noSelection.selectAsset')

    return (
        <Stack direction="column" gap={tokens.SizingSpacing300}>
            <Typography variant="headline1" color={tokens.ColorTextBoldest}>
                {t('explorer.title')}
            </Typography>
            <PlaceholderCard>
                <Pulse size="56px" color={tokens.ColorIconSubtle} />
                <Typography variant="textS" color={tokens.ColorTextSubtle}>
                    {noDataText}
                </Typography>
            </PlaceholderCard>
        </Stack>
    )
}
